import { createApp } from "vue";
import RecordingMap from "./RecordingMap.vue"
import store from "./store/store";
import { i18n } from '../../i18n';



if (document.querySelector('#recording_map')) {
  const app = createApp(RecordingMap)
  app.use(store);
  app.use(i18n);
  app.mount('#recording_map');
}
